import React, { useEffect, useState, useRef, lazy, createElement } from 'react';
import { CheckCircle } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    title: 'Instrucciones Paso a Paso, de la A a la Z',
    description: 'Recibes proyectos detallados con instrucciones paso a paso que hacen que fabricar muebles plegables sea súper rápido, súper fácil y súper satisfactorio. Es como tener a un MAESTRO CARPINTERO a tu lado, guiándote en cada paso del proyecto entero.'
  }, {
    title: 'Listas de Corte y Materiales EXACTAS',
    description: 'Recibes la lista EXACTA de materiales y cortes para cada proyecto. Vas a poder comprar las cantidades precisas — lo que significa que vas a dejar de tirar tu dinero en madera equivocada, materiales de más o cantidades que no sirven.'
  }, {
    title: 'Esquemas Detallados Con Medidas Exactas',
    description: 'Con esquemas claros y precisos incluidos en cada plano, simplemente NO HAY LUGAR PARA LA ADIVINANZA. El nivel de detalle convierte hasta el proyecto más desafiante en un paseo por el parque.'
  }, {
    title: 'Muebles Específicos Que Se Venden',
    description: 'No son planos genéricos de muebles que nadie quiere. Son diseños de piezas que la gente realmente busca y paga: Cama Murphy, Mesa Picnic Plegable, Escritorios Rebatibles, Estanterías Modulares y más.'
  }, {
    title: 'Apto Para Principiantes Absolutos Y Carpinteros Con Experiencia',
    description: 'Tenemos proyectos que cubren TODOS los niveles de habilidad y competencia. NO necesitas ser un maestro carpintero ni tener maquinaria costosa para usar nuestros planos.'
  }];
  const images = ['https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_28_1.webp?v=1771848321', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_26_1.webp?v=1771848163', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_29_1.webp?v=1771848632', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_30_1.webp?v=1771849030', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_27_1.webp?v=1771848183', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_31_1.webp?v=1771849153'];
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [wistiaLoaded, setWistiaLoaded] = useState(false);
  const videoRef = useRef<HTMLDivElement>(null);
  const carouselActiveRef = useRef(false);
  useEffect(() => {
    // Carousel auto-scroll — only runs when section is in viewport (saves mobile CPU)
    const scroller = scrollerRef.current;
    if (!scroller) return;
    let animationId: number;
    let scrollPosition = 0;
    const scrollSpeed = 0.9;
    const animate = () => {
      if (!carouselActiveRef.current) return;
      scrollPosition += scrollSpeed;
      if (scrollPosition >= scroller.scrollWidth / 2) {
        scrollPosition = 0;
      }
      scroller.scrollLeft = scrollPosition;
      animationId = requestAnimationFrame(animate);
    };
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        carouselActiveRef.current = true;
        animationId = requestAnimationFrame(animate);
      } else {
        carouselActiveRef.current = false;
        cancelAnimationFrame(animationId);
      }
    }, {
      threshold: 0.1
    });
    observer.observe(scroller);
    return () => {
      cancelAnimationFrame(animationId);
      observer.disconnect();
    };
  }, []);
  useEffect(() => {
    // Load Wistia only when video section enters viewport
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !wistiaLoaded) {
        setWistiaLoaded(true);
        const playerScript = document.createElement('script');
        playerScript.src = 'https://fast.wistia.com/player.js';
        playerScript.async = true;
        document.head.appendChild(playerScript);
        const embedScript = document.createElement('script');
        embedScript.src = 'https://fast.wistia.com/embed/h21ptcep8k.js';
        embedScript.async = true;
        embedScript.type = 'module';
        document.head.appendChild(embedScript);
        const style = document.createElement('style');
        style.textContent = `
            wistia-player[media-id='h21ptcep8k']:not(:defined) { 
              background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/h21ptcep8k/swatch'); 
              display: block; 
              filter: blur(5px); 
              padding-top: 56.25%; 
            }
          `;
        document.head.appendChild(style);
        observer.disconnect();
      }
    }, {
      rootMargin: '200px'
    });
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, [wistiaLoaded]);
  const projects = ['Cama Murphy Plegable', 'Mesa Picnic Plegable', 'Escritorio Rebatible de Pared', 'Estantería Modular', 'Mesa de Trabajo Plegable', 'Banco de Jardín', 'Organizador de Herramientas', 'Mueble Bar Plegable', 'Mesa para Balcón', 'Mueble de TV', 'Repisa Flotante', 'Mesa de Centro', 'Silla Plegable Premium', 'Mueble Zapatero', 'Cajonera de Melamina', 'Biblioteca Infantil', 'Mesa de Noche', 'Rack para Bicicletas', 'Mueble Multiuso', 'Carro de Cocina Plegable'];
  return <section className="py-8 md:py-16 px-4 bg-leather bg-blueprint" data-id="element-177">
      <div className="max-w-6xl mx-auto" data-id="element-178">
        {/* Project Types */}
        
         
          

          <div className="mb-6 md:mb-8" data-id="element-179">
            <div className="divider-industrial mb-6 md:mb-8" data-id="element-180"></div>
          </div>

          <div ref={scrollerRef} className="flex gap-4 md:gap-6 overflow-x-hidden mb-6 md:mb-8" style={{
        scrollBehavior: 'auto'
      }} data-id="element-181">
            {[...images, ...images].map((image, index) => <div key={index} className="flex-shrink-0 w-64 md:w-80 lg:w-96 h-64 md:h-80 lg:h-96 bg-[#111111] border-2 md:border-4 border-[#6F6F6F] shadow-[0_4px_0_0_#0a0a0a] md:shadow-[0_8px_0_0_#0a0a0a] overflow-hidden" data-id="element-182">
                <img src={image} alt={`Proyecto de carpintería ${index % images.length + 1}`} className="w-full h-full object-cover" loading="lazy" decoding="async" width="384" height="384" data-id="element-183" />
              </div>)}
          </div>

          <div className="mb-6 md:mb-8" data-id="element-184">
            <div className="divider-industrial" data-id="element-185"></div>
          </div>

          
        

        {/* Achievement Section */}
        <div className="max-w-4xl mx-auto mb-8 md:mb-16" data-id="element-186">
          <div className="prose prose-lg max-w-none" data-id="element-187">
            <p className="text-lg md:text-2xl text-[#E4D6B5] leading-relaxed mb-6 md:mb-8 font-bold text-center" data-id="element-188">
              <span className="font-black uppercase tracking-wide" data-id="element-189">
                ¿QUÉ LOGRARás?
              </span>
            </p>
            <div className="space-y-3 md:space-y-4 mb-8 md:mb-12" data-id="element-190">
              <div className="flex items-start gap-3 md:gap-4 bg-[#111111] p-3 md:p-5 border-l-4 border-[#8B5A2B] shadow-lg" data-id="element-191">
                <CheckCircle className="w-5 md:w-7 h-5 md:h-7 text-[#8B5A2B] flex-shrink-0 mt-1" data-id="element-192" />
                <p className="text-sm md:text-lg text-[#C8B894] leading-relaxed font-semibold" data-id="element-193">
                  Podrás fabricar tus primeros muebles plegables incluso sin
                  experiencia previa y usando herramientas sencillas.
                </p>
              </div>
              <div className="flex items-start gap-3 md:gap-4 bg-[#111111] p-3 md:p-5 border-l-4 border-[#8B5A2B] shadow-lg" data-id="element-194">
                <CheckCircle className="w-5 md:w-7 h-5 md:h-7 text-[#8B5A2B] flex-shrink-0 mt-1" data-id="element-195" />
                <p className="text-sm md:text-lg text-[#C8B894] leading-relaxed font-semibold" data-id="element-196">
                  Evitarás desperdiciar madera y dinero, porque sabrás
                  exactamente qué piezas cortar y cómo hacerlo correctamente.
                </p>
              </div>
              <div className="flex items-start gap-3 md:gap-4 bg-[#111111] p-3 md:p-5 border-l-4 border-[#8B5A2B] shadow-lg" data-id="element-197">
                <CheckCircle className="w-5 md:w-7 h-5 md:h-7 text-[#8B5A2B] flex-shrink-0 mt-1" data-id="element-198" />
                <p className="text-sm md:text-lg text-[#C8B894] leading-relaxed font-semibold" data-id="element-199">
                  Aprenderás a convertir la carpintería en un oficio rentable
                  desde tu casa y empezar a generar ingresos.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Closing Statement */}
        

        
      </div>
    
    </section>;
}